export enum LoginInterfaceStepStatus {
  START,
  FINISH,
  PROGRESS,
}
